import { gql } from "@/services/httpAdapter.ts";

export const TitlingFragment = gql`
	fragment Titling on Titling {
		_id
		locationId
		commissionCycleId
		payPeriodId
		vinNumber
		dealNumber
		stockNumber
		status
		creationDateTime
		saleDate
		financeManager {
			lastName
			financeManagerId
		}
		dealer {
			titlingNumber
			taxId
			contactInfo {
				dealerName
			}
		}
		miscellaneousInformation {
			hasCoOwner
			isOutOfStateSale
			isSold
			isFleetDeal
			unitOfMeasurement
			select1
			select2
			select3
			salesNumberReceipt
		}
		buyer {
			customerRecord {
				contactInfo {
					customerNumber
					firstName
					lastName
					midName
					ibFlag
					address {
						zipCode
					}
					phone {
						type
						extension
						number
					}
					email {
						mailTo
					}
				}
				dmsCustomerInfo {
					followUp {
						hasFollowUp
						followUpType
					}
				}
			}
		}
		coBuyer {
			customerRecord {
				contactInfo {
					customerNumber
					firstName
					lastName
					midName
					suffix
					ibFlag
					address {
						zipCode
					}
					phone {
						type
						extension
						number
					}
					email {
						mailTo
					}
				}
			}
		}
	}
`;
